module.exports = __webpack_public_path__ + "static/media/title_torikuzushi_simulation.54fd9244.svg";